import React from "react";

interface HealthProps extends React.SVGProps<SVGSVGElement> {
  fill?: string;
  stroke?: string;
  width?: number | string;
  height?: number | string;
}

const Health: React.FC<HealthProps> = ({
  fill = "#3C3C3C",
  stroke = "none",
  width = 24,
  height = 24,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.0732 20.5C10.2732 20.5 8.73991 19.8667 7.47324 18.6C6.20658 17.3333 5.57324 15.8 5.57324 14V13.425C4.13991 13.1917 2.94824 12.5208 1.99824 11.4125C1.04824 10.3042 0.573242 9 0.573242 7.5V1.5H3.57324V0.5H5.57324V4.5H3.57324V3.5H2.57324V7.5C2.57324 8.6 2.96491 9.54167 3.74824 10.325C4.53158 11.1083 5.47324 11.5 6.57324 11.5C7.67324 11.5 8.61491 11.1083 9.39824 10.325C10.1816 9.54167 10.5732 8.6 10.5732 7.5V3.5H9.57324V4.5H7.57324V0.5H9.57324V1.5H12.5732V7.5C12.5732 9 12.0982 10.3042 11.1482 11.4125C10.1982 12.5208 9.00658 13.1917 7.57324 13.425V14C7.57324 15.25 8.01074 16.3125 8.88574 17.1875C9.76074 18.0625 10.8232 18.5 12.0732 18.5C13.3232 18.5 14.3857 18.0625 15.2607 17.1875C16.1357 16.3125 16.5732 15.25 16.5732 14V12.325C15.9899 12.125 15.5107 11.7667 15.1357 11.25C14.7607 10.7333 14.5732 10.15 14.5732 9.5C14.5732 8.66667 14.8649 7.95833 15.4482 7.375C16.0316 6.79167 16.7399 6.5 17.5732 6.5C18.4066 6.5 19.1149 6.79167 19.6982 7.375C20.2816 7.95833 20.5732 8.66667 20.5732 9.5C20.5732 10.15 20.3857 10.7333 20.0107 11.25C19.6357 11.7667 19.1566 12.125 18.5732 12.325V14C18.5732 15.8 17.9399 17.3333 16.6732 18.6C15.4066 19.8667 13.8732 20.5 12.0732 20.5ZM17.5732 10.5C17.8566 10.5 18.0941 10.4042 18.2857 10.2125C18.4774 10.0208 18.5732 9.78333 18.5732 9.5C18.5732 9.21667 18.4774 8.97917 18.2857 8.7875C18.0941 8.59583 17.8566 8.5 17.5732 8.5C17.2899 8.5 17.0524 8.59583 16.8607 8.7875C16.6691 8.97917 16.5732 9.21667 16.5732 9.5C16.5732 9.78333 16.6691 10.0208 16.8607 10.2125C17.0524 10.4042 17.2899 10.5 17.5732 10.5Z"
        fill={fill}
        stroke={stroke}
      />
    </svg>
  );
};

export default Health;
